/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILanguageSelectorViewProps } from './language-selector';

export default (props: ILanguageSelectorViewProps) => {
    return (
        <div>
               <div className="dropdown">
                    <button className="dropbtn">Language</button>
                    <div className="dropdown-content">
                {(() => {
                    return props.config.cusLanguages?.map((cuslan, i) => {
                        return(
                            <a key={i} href={cuslan.siteURL}>{cuslan.languageCode}</a>
                        );
                    });
                })()}
                 </div>
            </div>
        </div>
    );
};
